import api from './api'

export const getNotificationSettings = () => {
  return api.get('/notifications/settings')
}

export const updateNotificationSettings = (settings) => {
  return api.put('/notifications/settings', settings)
}

export const getNotifications = (params = {}) => {
  return api.get('/notifications', { params })
}

export const markNotificationAsRead = (notificationId) => {
  return api.put(`/notifications/${notificationId}/read`)
}

export const markNotificationAsUnread = (notificationId) => {
  return api.put(`/notifications/${notificationId}/unread`)
}

export const markAllNotificationsAsRead = () => {
  return api.put('/notifications/read-all')
}


export const deleteNotification = (notificationId) => {
  return api.delete(`/notifications/${notificationId}`)
}

export const deleteAllNotifications = () => {
  return api.delete('/notifications')
}
